import { BasicTable } from '@/view/components/BasicTable'
import { useReportTransactionsController } from './useReportTransactionsController'
import { Spinner } from '@/view/components/ui/spinner'
import ProgressBar from '@ramonak/react-progress-bar'
import { Button } from '@/view/components/ui/button'
import { Download } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/view/components/ui/alert-dialog'
import { FilterReports } from '../components/FilterReports'
import { StatisticsCard } from '../../Dashboard/components/StatisticsCard'

export const ReportTransactions = () => {
  const {
    getPageCount,
    getPageIndex,
    handleNextPage,
    handlePreviousPage,
    isFetching,
    isLoading,
    table,
    handleExportToExcel,
    isExporting,
    exportProgress,
    setParams,
    filters,
    params,
  } = useReportTransactionsController()

  return (
    <div className="w-full">
      <div className="mb-5 flex flex-col items-center justify-between gap-4 max-md:w-full md:flex-row md:gap-0">
        <FilterReports filters={filters} setParams={setParams} />
        {isExporting && (
          <AlertDialog open={isExporting}>
            <AlertDialogContent className="w-96">
              <AlertDialogHeader>
                <AlertDialogTitle>
                  Seu download está em andamento
                </AlertDialogTitle>
              </AlertDialogHeader>
              <ProgressBar
                completed={exportProgress}
                maxCompleted={100}
                bgColor="#EA0356"
                width="330px"
              />
            </AlertDialogContent>
          </AlertDialog>
        )}
        <Button
          onClick={handleExportToExcel}
          className="flex items-center justify-center bg-primary font-semibold text-white hover:bg-primary max-md:w-full"
          disabled={isExporting}
        >
          <Download className="mr-2 h-5 w-5" />
          Exportar registros
        </Button>
      </div>
      <div className="mb-5 flex flex-col gap-5 rounded-2xl border border-border p-5 sm:min-w-[450px]">
        <StatisticsCard
          interval={false}
          hideCommission={true}
          onSelectDates={(d) => setParams((p) => ({ ...p, ...d }))}
          variant="full"
          reportTransactionParams={params}
          showCalendar={false}
        />
      </div>
      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}
      {!isFetching && table && (
        <BasicTable
          type="table with lines"
          getPageCount={getPageCount}
          getPageIndex={getPageIndex}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
          table={table}
        />
      )}
    </div>
  )
}
